var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-layout type-report"},[_c('main-navbar'),_c('div',{staticClass:"wrapper report",class:[{ 'nav-open': _vm.$sidebar.showSidebar }]},[_c('notifications'),_c('side-bar',{attrs:{"mini":true,"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('template',{slot:"links"},[_c('div',{staticClass:"profiles"},[_c('sidebar-item',{staticClass:"sidebar-item-plus",attrs:{"link":{
              name: 'Prospect Search',
              icon: 'source',
              path: '/prospect-search',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Industry Financial',
              icon: 'card_travel',
              path: '/new-profile/industry-financial-profile',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Industry Market',
              icon: 'leaderboard',
              path: '/new-profile/industry-market-profile',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Companies',
              icon: 'business',
              path: '/company-search',
            }}}),_c('div',{staticClass:"disable"},[_c('sidebar-item',{attrs:{"link":{
                name: 'Market',
                icon: 'insights',
                path: '/',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Franchise',
                icon: 'store',
                path: '/',
              }}})],1),_c('sidebar-item',{attrs:{"link":{
              name: 'Valuation Multiple',
              icon: 'addchart',
              path: '/valuation-multiple',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Financial Report',
              icon: 'text_snippet',
              path: '/create-report-format/financial',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Market Report',
              icon: 'newspaper',
              path: '/create-report-format/market',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Valuation Report',
              icon: 'request_quote',
              path: '/create-report-format/valuation',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Company Report',
              icon: 'summarize',
              path: '/create-report-format/company',
            }}})],1),_c('div',{staticClass:"section_wpr"},[_vm._v("My Data")]),_c('div',{staticClass:"profiles border-0"},[_c('sidebar-item',{attrs:{"link":{
              name: 'Prospect List',
              icon: 'format_list_bulleted',
              path: '/my-prospect-lists',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Profiles',
              icon: 'folder_open',
              path: '/my-profiles',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Reports',
              icon: 'description',
              path: '/my-reports',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Data',
              icon: 'dns',
              path: '/my-data',
            }}})],1)])],2),_c('app-side-bar',{attrs:{"mini":true,"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('mobile-menu'),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
            name: 'About the Data',
            icon: 'help',
            path: '/market-report/' + this.id + '/market-rep-about-data',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Competitive Summary',
            icon: 'star_half',
            path: '/market-report/' + this.id + '/competitive-summary',
            type: 'product',
          }}}),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'Competitors' }),expression:"{ name: 'Competitors' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Competitors',
              icon: 'location_on',
              path: '/market-report/' + this.id + '/market-rep-competitors',
              type: 'product',
            }}})],1),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'market' }),expression:"{ name: 'market' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Market',
              icon: 'trending_up',
              path: '/market-report/' + this.id + '/market-rep-market',
              type: 'product',
            }}})],1),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'market-rep-annual-sales' }),expression:"{ name: 'market-rep-annual-sales' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Annual Sales',
              icon: 'area_chart',
              path: '/market-report/' + this.id + '/market-rep-annual-sales',
              type: 'product',
            }}})],1),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Penetration',
            icon: 'business',
            path: '/market-report/' + this.id + '/market-rep-penetration',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Employment',
            icon: 'account_box',
            path: '/market-report/' + this.id + '/market-rep-employment',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Sales/Emp Classes',
            icon: 'price_change',
            path: '/market-report/' + this.id + '/market-rep-sales',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Productivity',
            icon: 'work',
            path: '/market-report/' + this.id + '/market-rep-productivity',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Startups',
            icon: 'settings_input_antenna',
            path: '/market-report/' + this.id + '/market-rep-startups',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Cessation',
            icon: 'area_chart',
            path: '/market-report/' + this.id + '/market-rep-cessation',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Ownership',
            icon: 'location_city',
            path: '/market-report/' + this.id + '/market-rep-ownership',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Demographics',
            icon: 'home',
            path: '/market-report/' + this.id + '/market-rep-demographics',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Manage Inputs',
            icon: 'settings',
            path: '/market-report/' + this.id + '/manage-inputs',
            type: 'product',
          }}}),_c('sidebar-item',{class:_vm.loading || this.isRetail ? 'non-subscriber' : '',attrs:{"link":{
            name: 'Customize Report',
            icon: 'tune',
            path: !this.isRetail
              ? '/market-report/' + this.id + '/customize-report'
              : this.currentPath,
            type: this.isRetail ? 'disabled' : 'product',
          }}})],1)],2),_c('div',{staticClass:"main-panel"},[_c('div',{class:{ content: !_vm.$route.meta.hideContent }},[(!_vm.isAboutRoute)?_c('div',{staticClass:"content"},[_c('PulseLoader',{class:{ hide: !_vm.loading },attrs:{"loading":_vm.loading,"quote":"Action is the foundational key to all success","author":"Pablo Picasso","profession":"Spanish Painter","img":"picasso.jpg"}})],1):_vm._e(),_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('div',{staticClass:"row"},[(!_vm.loading || _vm.isAboutRoute)?_c('router-view',{attrs:{"headerData":_vm.headerData}}):_vm._e()],1)])],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }